/**
 * EgoDeviceEditView Component
 *
 * Edit view for an existing eGO device at /ego/:deviceId.
 * Fetches current config and populates the form.
 *
 * Requirements: 2.3, 5.1–5.5
 */

import { useParams } from 'react-router-dom';
import { useEgoDevice } from '../hooks/useEgoDevice';
import { EgoConfigForm } from './EgoConfigForm';

export function EgoDeviceEditView(): JSX.Element {
  const { deviceId } = useParams<{ deviceId: string }>();
  const { config, lastUpdated, isLoading, error, isNotFound, refetch } = useEgoDevice(deviceId ?? '');

  if (isLoading) {
    return (
      <div className="ego-edit" style={{ padding: 32 }} role="status">
        <p>Loading…</p>
      </div>
    );
  }

  if (isNotFound) {
    return (
      <div className="ego-edit" style={{ padding: 32 }}>
        <p className="ego-form__error" role="alert">Device not found.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ego-edit" style={{ padding: 32 }}>
        <p className="ego-form__error" role="alert">{error}</p>
      </div>
    );
  }

  return (
    <div className="ego-edit" style={{ padding: 32 }}>
      <p className="ego-edit__device-id" style={{ fontWeight: 600, fontSize: '1.125rem', marginBottom: 8 }}>
        {deviceId}
      </p>
      {lastUpdated && (
        <p className="ego-edit__last-updated" style={{ fontSize: '0.875rem', color: '#666', marginBottom: 24 }}>
          Last updated: {new Date(lastUpdated).toLocaleString()}
        </p>
      )}
      <EgoConfigForm
        deviceId={deviceId!}
        initialConfig={config ?? undefined}
        mode="edit"
        onSaveSuccess={refetch}
      />
    </div>
  );
}
